// src/components/admin/ConversationList.js

import React, { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = "https://api.fitoja.in";

const ConversationList = ({ onSelectConversation }) => {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchConversations = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/chat/admin/conversations`
      );
      setConversations(response.data);
    } catch (error) {
      console.error("Error fetching conversations:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConversations();
    // Optional: Polling to refresh the list every X seconds
    const intervalId = setInterval(fetchConversations, 10000); // Refresh every 10 seconds
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="conversation-list-panel">
      <div style={{ display: "flex", alignItems: "center", paddingBottom: "10px"}}>
        <h2 style={{marginBottom: "0"}}>Active Chats ({conversations.length})</h2>
        <button
          style={{
            backgroundColor: "green",
            color: "white",
            border: "none",
            padding: "4px 12px",
            borderRadius: "4px",
            cursor: "pointer",
            marginLeft: "10px",
          }}
          onClick={fetchConversations}
        >
          Refresh
        </button>
      </div>
      {loading && <p>Loading chats...</p>}

      <ul className="chat-list">
        {conversations.map((convo) => (
          <li
            key={convo._id}
            className={`convo-item convo-status-${convo.status.toLowerCase()}`}
            onClick={() => onSelectConversation(convo)}
          >
            Conversation ID: {convo._id.slice(-6)}
            <span className="status-badge">{convo.status}</span>
            <small>
              Last: {new Date(convo.lastMessageAt).toLocaleTimeString()}
            </small>
            {convo.status === "Assigned" && <small> (Claimed by Agent)</small>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ConversationList;
